import React from "react";
import { useSelector } from "react-redux";

import { selectIsAuthorized } from "../../utils/auth/authSlice";
import LoginPage from "./LoginPage";
import VerificationPage from "./VerificationPage";

export default function Login() {
  const isAuthorized = useSelector(selectIsAuthorized);
  return isAuthorized ? <VerificationPage /> : <LoginPage />;
}
